import { BigNumber, Event as ContractEvent } from 'ethers'
import { Result as ContractResult } from '@ethersproject/abi'

export { default as useContract } from './useContract'
export { default as useERC20 } from './useERC20'
export { default as useGladiator } from './useGladiator'
export { default as useKnight } from './useKnight'
export { default as useMulticall2 } from './useMulticall2'
export { default as usePMT } from './usePMT'
export { default as useWTT } from './useWTT'

export namespace GladiatorTypes {
  interface PlayEventResult extends ContractResult {
    readonly player: Address
    readonly choice: BigNumber
    readonly result: BigNumber
    readonly amount: BigNumber
    readonly returnTt: BigNumber
    readonly returnToken: BigNumber
  }

  interface ClaimEventResult extends ContractResult {
    readonly player: Address
    readonly claimAmount: BigNumber
  }
  export namespace Event {
    export interface Play extends ContractEvent {
      args: PlayEventResult
    }
    export interface Claim extends ContractEvent {
      args: ClaimEventResult
    }
  }

  export enum Gladiator {
    Planet = 0,
    Thunder = 1,
  }
}

export namespace KnightTypes {
  interface JoinEventResult extends ContractResult {
    readonly id: BigNumber
    readonly joiner: Address
    readonly amount: BigNumber
    readonly fee: BigNumber
  }

  interface LeaveEventResult extends ContractResult {
    readonly id: BigNumber
    readonly leaver: Address
    readonly triggerer: Address
    readonly amount: BigNumber
    readonly profit: BigNumber
    readonly fee: BigNumber
  }

  interface QueenEventResult extends ContractResult {
    readonly id: BigNumber
    readonly queen: Address
    readonly triggerer: Address
    readonly profit: BigNumber
    readonly fee: BigNumber
  }

  export namespace Event {
    export interface Join extends ContractEvent {
      args: JoinEventResult
    }
    export interface Leave extends ContractEvent {
      args: LeaveEventResult
    }
    export interface Queen extends ContractEvent {
      args: QueenEventResult
    }
  }
}
